var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "회사소개",
      "sc": "에프원시큐리티가 여러분의 정보를 함께 보호하겠습니다.",
      "tabActive": "비전",
      "icon": "/images/sub/visual/sv1-icon.svg",
      "bg": "/images/sub/visual/sv1.png"
    }
  }), _c('section', {
    staticClass: "sub-section sub-section--last"
  }, [_c('v-container', [_c('h3', {
    staticClass: "sub-tit--lg mb-28 mb-lg-54",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('span', {
    staticClass: "color-point"
  }, [_vm._v("F1 Security")]), _vm._v(" 는 소중한 정보를 보호합니다. ")])]), _c('div', {
    staticClass: "py-60 py-lg-100 vision-bg mb-60 mb-lg-100"
  }, [_c('v-container', [_c('v-img', {
    staticClass: "d-none d-md-block mx-auto",
    attrs: {
      "max-width": "900",
      "src": "/images/sub/about/vision/vision-img.png"
    }
  }), _c('v-img', {
    staticClass: "d-block d-md-none mx-auto",
    attrs: {
      "max-width": "670",
      "src": "/images/sub/about/vision/vision-img-mo.png"
    }
  })], 1)], 1), _c('v-container', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "radius-sm border w-100 h-100 pa-16 py-md-46 px-md-38",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-delay": "100"
    }
  }, [_c('h5', {
    staticClass: "sub-tit--sm mb-8 mb-lg-14"
  }, [_vm._v("MAN POWER")]), _c('p', {
    staticClass: "page-text color-gray"
  }, [_vm._v(" 정보보호컨설팅 전문 고급인력을 양성합니다. "), _c('br'), _vm._v(" 전문지식과 다양한 경험을 갖춘 우수인력을 보유하여 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 고객의 요구사항에 신속하게 대응합니다. ")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "radius-sm border w-100 h-100 pa-16 py-md-46 px-md-38",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-delay": "400"
    }
  }, [_c('h5', {
    staticClass: "sub-tit--sm mb-8 mb-lg-14"
  }, [_vm._v("TEAM WORK")]), _c('p', {
    staticClass: "page-text color-gray"
  }, [_vm._v(" 뛰어난 팀워크와 자율적인 조직문화를 형성합니다. "), _c('br'), _vm._v(" 공동의 목표설정 및 적극적인 해결능력으로 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 훌륭한 팀워크를 보여줍니다. ")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "radius-sm border w-100 h-100 pa-16 py-md-46 px-md-38",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-delay": "700"
    }
  }, [_c('h5', {
    staticClass: "sub-tit--sm mb-8 mb-lg-14"
  }, [_vm._v("VALUE OF CUSTOMER")]), _c('p', {
    staticClass: "page-text color-gray"
  }, [_vm._v(" 높은 수준의 차별화된 컨설팅 서비스를 제공합니다. "), _c('br'), _vm._v(" 고객서비스 중심의 보안솔루션과 AI기술을 적용한 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 첨단 솔루션을 개발하여 제공합니다. ")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "radius-sm border w-100 h-100 pa-16 py-md-46 px-md-38",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-delay": "1000"
    }
  }, [_c('h5', {
    staticClass: "sub-tit--sm mb-8 mb-lg-14"
  }, [_vm._v("HIGH QUALITY")]), _c('p', {
    staticClass: "page-text color-gray"
  }, [_vm._v(" 최신 보안기술동향 및 정보보호 관련 법령을 반영합니다. "), _c('br'), _vm._v(" 최적화된 컨설팅 방법론을 보유하고 있습니다. "), _c('br'), _vm._v(" 최신 정보기술의 적용으로 안정적인 정보보호 서비스를 제공합니다. ")])])])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }